import React from "react";
import MainBody from "../../Components/Body/MainBody";
import { useLocation, useParams } from "react-router-dom";
import CategoryPage from "../category/CategoryPage";
import { Alert } from "react-bootstrap";
import Featured from "../../Components/Body/Featured";

const Home = () => {
  // useParams -> Returns an object of key/value pairs of the dynamic params from the current URL that were matched by the route path.
  let { category } = useParams();

  const location = useLocation();

  return (
    <>
      <p className="hidden_desc">
        Providing mobile accessories and electronics. Operating from our central
        business location at the Magic Business Center, Mfangano Street, Nairobi
        CBD, we specialize in offering a wide range of high quality phone
        products, including chargers, earphones, cases, batteries, screen
        protectors, and more.
      </p>
      {location.state?.notification && (
        <Alert
          className="alert-customizing"
          variant="success"
          autoFocus={true}
          dismissible
        >
          {location.state.notification}
        </Alert>
      )}
      {category ? (
        <CategoryPage categoryName={category} />
      ) : (
        <>
          {/* <Banner /> */}
          <Featured />
          <MainBody />
        </>
      )}
    </>
  );
};

export default Home;
